import React, {Component} from "react";
import {
  setBudgetYearFilter,
} from "../../../../actions/actions/eventStats";
import {connect} from "react-redux";
import {budgetYearFilterStyle, getBudgetManagementYears, getYears} from "../../../../services/utils";
import ReactSelect, {components} from "react-select";
import {
  fetchBudgetData,
  generateFollowUp, updateFollowUp
} from "../../../../actions/thunks/eventStats";
import FilterModal from "../../../common/BudgetManagement/FilterModal";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'pr-2 pl-2'}/>
    </components.DropdownIndicator>
  );
};

class YearFilter extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      nextYear: '',
    };
  }
  handleDontSaveClick = () => {
    this.props.setBudgetYearFilter(this.state.nextYear);
    this.setState({visible : false})
  };

  handleSaveClick = () => {
    const {followUp} = this.props.budgetManagement;

    if (followUp.length === 0){
      const {appType, year,budgetPerMonth, globalBudget:{totalHTVA ,registrantsCount, pricePerUnit}} = this.props.budgetManagement;
      this.props.generateFollowUp(appType, year,budgetPerMonth, totalHTVA, registrantsCount, pricePerUnit).then( () => {
        this.props.setBudgetYearFilter(this.state.nextYear);
        this.setState({visible : false});
      });
    } else  {
      const {annualTargetId, followUp} = this.props.budgetManagement;
      this.props.updateFollowUp(annualTargetId, followUp).then( () => {
        this.props.setBudgetYearFilter(this.state.nextYear);
        this.setState({visible : false});
      });
    }
  };

  handleCancelClick = () => {
    this.setState({visible : false})
  };

  handleSelectChange = (value) => {
    const {
      followUp,
      originalFollowUp,
      budgetPerMonth,
      originalBudgetPerMonth
    } = this.props;

    const followUpIsUnchanged = followUp.every((element, index) => element.registrantsCount === originalFollowUp[index].registrantsCount && element.followUpPricePerUnit === originalFollowUp[index].followUpPricePerUnit);
    const budgetPerMonthIsUnchanged = budgetPerMonth.every((element, index) => element.registrantsCount === originalBudgetPerMonth[index].registrantsCount);

    if (followUpIsUnchanged && budgetPerMonthIsUnchanged) {
      this.props.setBudgetYearFilter(value.value);
    } else {
      this.setState({visible: true, nextYear: value.value})
    }
  }

  render() {
    const {budgetManagement} = this.props;
    const {visible} = this.state;

    return (
      <div>
        <ReactSelect
          className="create-BM-date-filter"
          onChange={this.handleSelectChange}
          styles={budgetYearFilterStyle()}
          value={{value: this.props.budgetManagement.year, label: this.props.budgetManagement.year}}
          placeholder={this.props.budgetManagement.year}
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
            Input: () => null
          }}
          options={getBudgetManagementYears().filter(year => year !== budgetManagement.year[0]).map((year) => ({
            value: year,
            label: year
          }))}
        />
        <FilterModal
          visible={visible}
          budgetManagement={budgetManagement}
          handleDontSaveClick={this.handleDontSaveClick}
          handleSaveClick={this.handleSaveClick}
          handleCancelClick={this.handleCancelClick}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
  followUp: state.budgetManagement.followUp,
  originalFollowUp: state.budgetManagement.originalFollowUp,
  budgetPerMonth: state.budgetManagement.budgetPerMonth,
  originalBudgetPerMonth: state.budgetManagement.originalBudgetPerMonth,
});

const mapDispatchToProps = {
  setBudgetYearFilter,
  generateFollowUp,
  updateFollowUp,
  fetchBudgetData
};

export default connect(mapStateToProps, mapDispatchToProps)(YearFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/BudgetManagement/YearFilter.js